import { gqlClient } from "@/preset/apollo-options";
import { inMobileApp } from "./mobile/MobileApp";

/**
 * 获取分页参数，pageInput
 * @param paging
 */
export const getPageInputParams = (paging: any = {}) => {
  const { pageNum, pageSize } = paging;
  return { pageNum, pageSize };
};
/**
 * 获取返回数据
 */
export const getResData = (res: any) => {
  return res?.data?.data?.data;
};
/**
 * 获取返回数据
 */
export const getRes = (res: any) => {
  return res?.data?.data;
};
/**
 * send request
 * @param 请求参数
 * @param options 定制化请求
 * @param options.custom true -> 返回response；false -> 返回response.data
 */
export const queryRequest = async (params: any, { custom = false } = {}) => {
  return (custom ? getRes : getResData)(await gqlClient(params)) ?? {};
};

/**
 * 处理分页数据
 * @param data
 */
export const handlePaginationData = (data: any) => {
  return {
    data: data?.dataList?.map(o => o.data) || [],
    ...data?.pageInfo
  };
};

/**
 * 返回错误对象数组
 * @param message 错误对象字符串
 */
export const generateErrorData = (message: string) => {
  try {
    return JSON.parse(message.split("GraphQL error: ").filter(Boolean)[0]);
  } catch (e) {
    return [];
  }
};

/**
 * 封装一个全局获取token的接口
 */
export const getToken: any = () => {
  if (inMobileApp()) {
    // 页面第一次加载，重新获取token
    // notFirst 变量默认为 undefined
    if (getToken.notFirst && getToken.promise) {
      return getToken.promise;
    }

    let promise = new Promise(async resolve => {
      if (getToken.notFirst && localStorage.getItem("token")) {
        resolve(localStorage.getItem("token"));
        return;
      }
      let token = await window.nativeApp.setToken();
      console.log("request token", token, "token");
      token && localStorage.setItem("token", token);
      // 状态
      getToken.notFirst = true;
      resolve(token);
    });
    return (getToken.promise = promise);
  } else {
    return localStorage.getItem("token");
  }
};
